import b from "./_common.js";
import { createTheme as I } from "../../_mixins/use-theme.js";
import L from "../../_styles/common/light.js";
import v from "../../button/styles/light.js";
function H(r) {
  const {
    textColor1: e,
    textColor2: t,
    modalColor: l,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: c,
    closeColorHover: s,
    closeColorPressed: C,
    infoColor: m,
    successColor: a,
    warningColor: g,
    errorColor: d,
    primaryColor: f,
    dividerColor: u,
    borderRadius: o,
    fontWeightStrong: h,
    lineHeight: p,
    fontSize: x
  } = r;
  return Object.assign(Object.assign({}, b), {
    fontSize: x,
    lineHeight: p,
    border: `1px solid ${u}`,
    titleTextColor: e,
    textColor: t,
    color: l,
    closeColorHover: s,
    closeColorPressed: C,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: c,
    closeBorderRadius: o,
    iconColor: f,
    iconColorInfo: m,
    iconColorSuccess: a,
    iconColorWarning: g,
    iconColorError: d,
    borderRadius: o,
    titleFontWeight: h
  });
}
const S = I({
  name: "Dialog",
  common: L,
  peers: {
    Button: v
  },
  self: H
}), P = S;
export {
  P as default,
  H as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/styles/light.js
// module id = 949
// module chunks = 67